import { Alert, Grid } from "@mui/material";
import { useContext, useEffect } from 'react';
import { PermissionType } from 'src/types/security';
import { useLoader } from "../../../../hooks/useLoader";
import { QueryStatus } from "../../../../types";
import { SistemaTipo } from "../../../../types/enum/enum";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import SeccionLCLSDatosOperacion from "./components/SeccionLCLSDatosOperacion";
import SeccionLCLSLimitesTabla from "./components/SeccionLCLSLImitesTabla";
import { useOperacionLCLS } from "./hooks/useOperacionLCLS";
import { OperacionLCLS } from "./types/types";


interface SistemaLCLSContentProps {
  operacion: OperacionLCLS,
  permisoTipo: PermissionType
}

const SistemaLCLSContent = ({ operacion, permisoTipo }: SistemaLCLSContentProps) => {
  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionLCLSDatosOperacion
            operacion={operacion}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionLCLSLimitesTabla operacion={operacion}
            permiteEditar={permisoTipo >= PermissionType.Write}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionFirmas
            codSistema={SistemaTipo.LCLS}
            idOperacion={operacion.id}
          />
        </Grid>
      </Grid>
    </>
  )
}

function SistemaLCLS() {
  const { idOperacion, permisoTipo } = useContext<ContextOperacionType>(ContextOperacion);
  const { status, operacion } = useOperacionLCLS(idOperacion);
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status]);

  if (!operacion) {
    return null;
  }

  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  return (
    <SistemaLCLSContent
      operacion={operacion}
      permisoTipo={permisoTipo}
    />
  )
}

export default SistemaLCLS;